<span *ngIf="!maximised" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{widget.caption}}</span>
<div class="chart-container relative full-width" [ngStyle]="{'height': maximised ? '-webkit-fill-available' : '70px'}">
  <canvas #canvas width="100%" baseChart [data]="chartData" [options]="chartOptions" [type]="chartType"></canvas>
</div>